// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, DataListItem, Dialog, Illustration } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useAccountPreferencesQuery } from 'hooks/queries/useAccountPreferencesQuery'
import { useApprovalsContext } from 'hooks/useApprovalsContext'
import {
  useApiInitiatedApproval,
  useApprovalFlowsCheckboxOptions,
} from './hooks/useApprovalsFlowSettings'

const ApprovalPreferenceSuccessModal = () => {
  const { t } = useTranslation()

  const {
    permissions,
    approvalsConfig: {
      handleApprovalPreferenceSuccessModal,
      handleApprovalPreferenceSettingsModal,
      approvalPreferences,
      approvalPreferencesLimits,
    },
  } = useApprovalsContext()

  const { approvalFlowCheckboxOptions } = useApprovalFlowsCheckboxOptions(approvalPreferences)
  const { isApiApprovalFlowPresent, isApiApprovalEnabled } =
    useApiInitiatedApproval(approvalPreferences)

  const {
    profile: { currencyCode },
  } = useProfileContext()
  const { data: accountPreferences, isLoading: isLoadingAccountPreferences } =
    useAccountPreferencesQuery()
  const baseCurrency =
    (!isLoadingAccountPreferences && (accountPreferences?.currency || currencyCode)) || ''

  const handleResetForm = () => handleApprovalPreferenceSuccessModal({ isVisible: false })
  const handleClose = () => {
    handleResetForm()
    handleApprovalPreferenceSettingsModal({ isVisible: false })
  }

  const approvalFlowCheckboxOptionsString = approvalFlowCheckboxOptions
    .filter(item => item?.checked)
    .map(item => item?.label)
    .join(', ')

  return (
    <Dialog
      open
      onClose={handleClose}
      title={t('approvals.rulesSaved')}
      Illustration={<Illustration name="HandsClapping" color="success" />}
      ActionButtons={[
        <Button key="done" onClick={handleClose}>
          {t('done')}
        </Button>,
        permissions?.canEdit && (
          <Button key="addAnotherRule" variant="secondary" onClick={handleResetForm}>
            {t('approvals.addAnotherRule')}
          </Button>
        ),
      ]}
    >
      <Box>
        <DataListItem
          id="approval-description"
          testId="approval-description"
          title={t('approvals.typeOfOutgoingPayment')}
          body={approvalFlowCheckboxOptionsString}
          layout="vertical"
        />

        {approvalPreferencesLimits?.map((limit, index) => (
          <DataListItem
            key={`${limit?.minAmount}-${limit?.maxAmount}`}
            id={`preference-${index}`}
            testId={`preference-${index}`}
            title={`${t('approvals.condition')} ${index + 1}`}
            body={`${t('from')} ${limit?.minAmount} - ${limit?.maxAmount} ${baseCurrency}; ${limit?.approvalsCount} ${limit?.approvalsCount === 1 ? t('approvals.approver')?.toLowerCase() : t('approvals.approvers')?.toLowerCase()}`}
            layout="vertical"
          />
        ))}

        {isApiApprovalFlowPresent && (
          <DataListItem
            id="approval-api-payments"
            testId="approval-api-payments"
            title={t('approvals.applySameRulesToApi')}
            body={isApiApprovalEnabled ? t('yes') : t('no')}
            layout="vertical"
          />
        )}
      </Box>
    </Dialog>
  )
}

export default React.memo(ApprovalPreferenceSuccessModal)
